<template>
	<TTextInput
		disabled
		:label="header"
		:value="value"
	/>
</template>

<script>
export default {
	props: {
		header: String,
		value: [ String, Number, Boolean ]
	}
};
</script>

<style lang="scss" scoped>

@import '~@/components/evergreen/scss/text';
.header-text{
	@extend %text-medium;
	font-weight: bold;
}

.value-text {
	@extend %text-small;
}

</style>